/**
 * Lais (Marie de France) metadata + config
 */

const metadataChapters = [
  { chapt_num: 1, chapt_name: 'I. Prologue: By Way of Dedication', subtitle: 'Section 1', hasAssessment: false, chunk: 'lays-003' },
  { chapt_num: 2, chapt_name: 'II. The Lay of Gugemar', subtitle: 'Sections 1 - 18', hasAssessment: false, chunk: 'lays-004' },
  { chapt_num: 3, chapt_name: 'III. The Lay of the Dolorous Knight', subtitle: 'Sections 1 - 5', hasAssessment: false, chunk: 'lays-005' },
  { chapt_num: 4, chapt_name: 'IV. The Lay of Eliduc', subtitle: 'Sections 1 - 11', hasAssessment: false, chunk: 'lays-006' },
  { chapt_num: 5, chapt_name: 'V. The Lay of the Nightingale', subtitle: 'Sections 1 - 10', hasAssessment: true, chunk: 'lays-007' },
  { chapt_num: 6, chapt_name: 'VI. The Lay of Sir Launfal', subtitle: 'Sections 1 - 14', hasAssessment: true, chunk: 'lays-008' },
  { chapt_num: 7, chapt_name: 'VII. The Lay of the Two Lovers', subtitle: 'Sections 1 - 5', hasAssessment: false, chunk: 'lays-009' },
  { chapt_num: 8, chapt_name: 'VIII. The Lay of the Were-Wolf', subtitle: 'Sections 1 - 3', hasAssessment: true, chunk: 'lays-010' },
  { chapt_num: 9, chapt_name: 'IX. The Lay of the Ash Tree', subtitle: 'Sections 1 - 24', hasAssessment: false, chunk: 'lays-011' },
  { chapt_num: 10, chapt_name: 'X. The Lay of the Honeysuckle', subtitle: 'Sections 1 - 11', hasAssessment: false, chunk: 'lays-012' },
  { chapt_num: 11, chapt_name: 'XI. The Lay of Equitan', subtitle: 'Sections 1 - 5', hasAssessment: false, chunk: 'lays-013' },
  { chapt_num: 12, chapt_name: 'XII. The Lay of Milon', subtitle: 'Section 1', hasAssessment: false, chunk: 'lays-014' },
  { chapt_num: 13, chapt_name: 'XIII. The Lay of Yonec', subtitle: 'Sections 1 - 7', hasAssessment: false, chunk: 'lays-015' },
  { chapt_num: 14, chapt_name: 'XIV. The Lay of the Thorn', subtitle: 'Sections 1 - 10', hasAssessment: false, chunk: 'lays-016' },
  { chapt_num: 15, chapt_name: 'XV. The Lay of Graelent', subtitle: 'Sections 1 - 13', hasAssessment: false, chunk: 'lays-017' },
  { chapt_num: 16, chapt_name: 'XVI. A Story of Beyond the Sea', subtitle: 'Sections 1 - 29', hasAssessment: false, chunk: 'lays-018' },
  { chapt_num: 17, chapt_name: 'XVII. The Chatelaine of Vergi', subtitle: 'Sections 1 - 18', hasAssessment: false, chunk: 'lays-019' }
];

const extractStanzaRange = (subtitle) => {
  if (!subtitle) return null;
  const trimmed = subtitle.trim();
  const prefix = 'Sections ';
  const prefixSingle = 'Section ';
  if (trimmed.startsWith(prefix)) {
    return trimmed.slice(prefix.length);
  } else if (trimmed.startsWith(prefixSingle)) {
    return trimmed.slice(prefixSingle.length);
  }
  return null;
};

export const chapters = metadataChapters.map((chapter) => ({
  chapter_id: chapter.chapt_num,
  chapt_num: chapter.chapt_num,
  chapt_name: chapter.chapt_name,
  subtitle: chapter.subtitle,
  stanzaRange: extractStanzaRange(chapter.subtitle),
  hasAssessment: chapter.hasAssessment,
  chunk: chapter.chunk
}));

const getChapterByChunk = (chunk) => chapters.find(ch => ch.chunk === chunk);

export const config = {
  id: 'Lais',
  displayName: 'The Lays of Marie de France',
  author: 'Marie de France',
  coverImage: 'Lais.png',
  route: 'Lais',
  type: 'lais',
  contentKey: 'Lais',
  bookId: 'lais',
  usesExternalLinks: false,

  getTitleForChunk: function(chunk) {
    const chapter = getChapterByChunk(chunk);
    if (chapter) {
      if (chapter.chapt_name && chapter.chapt_name.trim()) {
        return chapter.chapt_name.trim();
      }
      return `Chapter ${chapter.chapt_num}`;
    }
    // Fallback parsing
    const match = chunk.match(/lays-(\d+)/);
    if (match) {
      const chunkNum = parseInt(match[1], 10);
      return `Lay ${chunkNum - 2}`;
    }
    return chunk;
  },

  getSubtitle: function(fragmentRange, _level, _showCefrLevel, chunk) {
    const chapter = getChapterByChunk(chunk);
    if (chapter?.subtitle) {
      return chapter.subtitle;
    }
    if (fragmentRange?.start && fragmentRange?.end) {
      return `Sections ${fragmentRange.start} - ${fragmentRange.end}`;
    }
    return 'The Lais of Marie de France';
  }
};

const book = { config, chapters };

export default book;
